import DocumentStatus from "./DocumentStatus";

export default DocumentStatus;
